import Entry from './SiteElements/Entry';

function App() {
  return (
    <Entry/>
  );
}

export default App;
